var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23709 20.7746L18.4431 11.9625C19.5484 10.9045 19.5484 9.18909 18.4431 8.13109M3.5 11.707L10.9716 4.55514C14.0664 1.59272 19.0841 1.59272 22.1789 4.55514",
    stroke: "#939CB4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.1788 15.2829L22.6974 15.8246L22.1788 15.2829ZM12.9061 24.1589L12.3875 23.6171L12.9061 24.1589ZM5.30112 16.8793L5.81973 17.4211L5.30112 16.8793ZM14.4404 8.13096L13.9218 7.58916L14.4404 8.13096ZM22.6974 4.01321C22.3982 3.72679 21.9235 3.73717 21.637 4.03639C21.3506 4.33562 21.361 4.81038 21.6602 5.0968L22.6974 4.01321ZM21.6602 14.7411L12.3875 23.6171L13.4247 24.7007L22.6974 15.8246L21.6602 14.7411ZM5.81973 17.4211L14.959 8.67275L13.9218 7.58916L4.7825 16.3375L5.81973 17.4211ZM18.9617 7.58916C17.5664 6.25355 15.3171 6.25355 13.9218 7.58916L14.959 8.67275C15.7743 7.89235 17.1092 7.89235 17.9244 8.67275L18.9617 7.58916ZM5.81973 23.6171C4.02819 21.9022 4.02819 19.1359 5.81973 17.4211L4.7825 16.3375C2.37393 18.643 2.37393 22.3951 4.7825 24.7007L5.81973 23.6171ZM12.3875 23.6171C10.5774 25.3497 7.62977 25.3497 5.81973 23.6171L4.7825 24.7007C7.17258 26.9885 11.0346 26.9885 13.4247 24.7007L12.3875 23.6171ZM21.6602 5.0968C24.4465 7.7639 24.4465 12.074 21.6602 14.7411L22.6974 15.8246C26.1008 12.5669 26.1008 7.27094 22.6974 4.01321L21.6602 5.0968Z",
    fill: "#939CB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.b2798ef8d4695c15f6850ba76575025d.svg";
export { ForwardRef as ReactComponent };